/**
 * /tenants/$slug/authentication/authenticators — Approved models.
 *
 * The list's search, added-by filter, Windows roaming filter, sort and page
 * live in the URL, validated here; a bad value falls back to the default view
 * rather than failing the route.
 */

import { createFileRoute } from "@tanstack/react-router";
import { approvedModelsSearchSchema } from "@/features/authenticator-allowlist/schemas";
import { ApprovedModelsPage } from "@/features/authenticator-allowlist/pages/approved-models-page";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/authenticators/")({
  validateSearch: approvedModelsSearchSchema.parse,
  component: ApprovedModelsPage,
});
